import { inject, Injectable, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog'
import { Subscription } from 'rxjs'
import { showSpinner } from '../../store/handler/handler.selectors'
import { SpinnerComponent } from './spinner.component'

@Injectable({ providedIn: 'root' })
export class SpinnerService implements OnDestroy {
   private _store = inject(Store)
   private _dialogService = inject(DialogService)
   private spinnerDialogRef = inject(DynamicDialogRef<SpinnerComponent>)

   private _isShow?: boolean
   private _sub = new Subscription()

   constructor() {
      this._sub.add(
         this._store.select(showSpinner).subscribe((v) => {
            v ? this.showSpinner() : this._isShow ? this.closeSpinner() : null
         })
      )
   }

   public showSpinner() {
      this.spinnerDialogRef = this._dialogService.open(SpinnerComponent, {
         modal: true,
         closable: false,
         showHeader: false,
         focusOnShow: false,
         styleClass: 'shadow-none spinner-dialog-content contents',
      })
      this._isShow = true
   }

   private closeSpinner() {
      this.spinnerDialogRef?.close()
   }

   ngOnDestroy(): void {
      this.closeSpinner()
      this._sub.unsubscribe()
   }
}
